import { useTranslation } from "react-i18next";

import { Button, Typography } from "@aviary";
import { Container } from "@aviary/layouts";
import { SvgFullscriptIcon } from "@shared/assets/logo";
import { l } from "@shared/locales/i18n";

import * as styles from "./ErrorFallback.styles";

interface Props {
  hideBackToHome?: boolean;
}

const DEFAULT_PROPS = {
  hideBackToHome: false,
};

const ErrorFallback = ({ hideBackToHome }: Props = DEFAULT_PROPS) => {
  const { t } = useTranslation();

  const renderBackToHome = () => {
    if (hideBackToHome) return null;

    return (
      <Button to="/" isColor="primary">
        {t(l.errorBoundary.BackToHome)}
      </Button>
    );
  };

  return (
    <Container css={styles.errorBoundary}>
      <div css={styles.content}>
        <Typography css={styles.title} type="h1">
          {t(l.errorBoundary.Oops)}
        </Typography>

        <div css={styles.subTitleContainer}>
          <SvgFullscriptIcon css={styles.logo} />
          <Typography type="h2" sizeOverride="h4">
            {t(l.errorBoundary.ApplicationErrorText)}
          </Typography>
        </div>
        <Typography css={styles.text}>{t(l.errorBoundary.ApplicationErrorMessage)}</Typography>
        {renderBackToHome()}
      </div>
    </Container>
  );
};

export { ErrorFallback };
